import { MapContainer } from 'react-leaflet'
import Map from './Map'
import useMapInitialBounds from '../../../hooks/useMapInitialBounds'

export default function OperatorMap({
  items,
  slug,
  toggleMap,
  countryCode,
  locationBounds,
}) {
  const { initBounds } = useMapInitialBounds(locationBounds, items, true)

  return (
    <MapContainer
      zoomControl={false}
      bounds={initBounds}
      zoom={13}
      center={[47, 18]}
      maxZoom={18}
      scrollWheelZoom
      style={{ height: '600px' }}
    >
      <Map
        pins={items}
        slug={slug}
        countryCode={countryCode}
        toggleMap={toggleMap}
        initBounds={initBounds}
      />
    </MapContainer>
  )
}
